/* 🤖 this file was generated by svg-to-ts */
export const mgcIconBowlCuteFi: {
  name: 'bowl-cute-fi';
  data: string;
} = {
  name: 'bowl-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.82 4.579c-1.316.244-2.496 1.18-3.001 2.379-.257.609-.279.759-.278 1.862.001.864.013 1.07.093 1.513.515 2.88 2.145 5.224 4.566 6.565a9.477 9.477 0 0 0 1.469.643c.323.104.329.109.351.253.157 1.017.81 1.796 1.76 2.097.273.087.327.089 2.22.089s1.947-.002 2.22-.089c.948-.3 1.601-1.078 1.759-2.097.023-.144.03-.149.352-.253 2.197-.708 4.082-2.364 5.168-4.537a9.66 9.66 0 0 0 .942-3.234c.068-.587.031-1.911-.061-2.25-.383-1.396-1.47-2.47-2.92-2.886l-.32-.092-7.02-.008c-5.623-.006-7.076.003-7.3.045"/></svg>`
};
